import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

const treeBarsData = {
  children: [{
    id: 1,
    text: i18n.getString('HotelCenter_Intelligence_Feeds_Title'),
    name: 'Feeds',
    hasChildren: true,
    children: [{
      id: 1,
      text: i18n.getString('HotelCenter_Intelligence_FeedUpload_Title'),
      name: 'Feed Upload',
      hasChildren: false,
    }, {
      id: 2,
      text: i18n.getString('HotelCenter_Intelligence_MatchingReport_Title'),
      name: 'Matching Report',
      hasChildren: false,
    }, {
      id: 3,
      text: i18n.getString('HotelCenter_Intelligence_FeedStatus_Title'),
      name: 'Feed Status',
      hasChildren: false,
    }],
  }, {
    id: 2,
    text: i18n.getString('HotelCenter_SOV_Report_Title'),
    name: 'SOV Report',
    hasChildren: false,
  }],
};

const bookingMenu = {
  id: 3,
  text: i18n.getString('HotelCenter_Booking_Report_Title'),
  name: 'Booking Report',
  hasChildren: false,
};

treeBarsData.children.push(bookingMenu);

const menu = {
  id: 4,
  text: i18n.getString('HotelCenter_Intelligence_AdExtensions_Title'),
  name: 'Ad Extensions',
  hasChildren: true,
  children: [{
    id: 1,
    text: i18n.getString('HotelCenter_Intelligence_CalloutExtensions_Title'),
    name: 'Callout Extensions',
    hasChildren: false,
  }],
};

treeBarsData.children.push(menu);

export function getList() {
  return treeBarsData;
}

export function getViewNameById(sectionIndex) {
  return _.reduce(
    sectionIndex, (memo, index) => memo.result('children')
      .findWhere({ id: index }),
    _.chain(treeBarsData)
  )
    .result('name')
    .value();
}

